<template>
    <div class="main-content astranaut-bg">
        <section class="text-center vertical-center">
            <div class="save-document-form" style="margin: auto;">
                <h2>Your are not a member of any team yet.</h2>
                <p>It’s the perfect moment to create your own one</p>
                <router-link :to="{ name: 'Create Team' }" class="btn btn-primary mr-0 mt-3 mx-auto">Create a team
                </router-link>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "Intro"
}
</script>

<style scoped>
.astranaut-bg {
    margin: auto -72px;
    background-image: url('/assets/img/astranaut.svg');
    height: 70%;
    background-position: top;
    background-size: auto;
    background-repeat-y: no-repeat;
}
</style>
